function escape(str) {
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

const HR_RE = /^\s*([-*_])\s*(?:\1\s*){2,}$/;
const TABLE_SEP_RE = /^\s*\|?\s*:?-+:?\s*(\|\s*:?-+:?\s*)+\|?\s*$/;

function splitTableRow(line) {
    let s = line.trim();
    if (s.startsWith('|')) s = s.slice(1);
    if (s.endsWith('|')) s = s.slice(0, -1);
    return s.split('|').map((c) => c.trim());
}

function renderTable(lines) {
    const headerCells = splitTableRow(lines[0]);
    const bodyLines = lines.slice(2);

    const thead =
        '<thead><tr>' +
        headerCells.map((c) => '<th>' + renderInline(c) + '</th>').join('') +
        '</tr></thead>';

    const tbody =
        bodyLines.length === 0
            ? ''
            : '<tbody>' +
              bodyLines
                  .map((line) => splitTableRow(line))
                  .map(
                      (row) =>
                          '<tr>' +
                          row.map((c) => '<td>' + renderInline(c) + '</td>').join('') +
                          '</tr>'
                  )
                  .join('') +
              '</tbody>';

    return '<table>' + thead + tbody + '</table>';
}

function renderInline(text) {
    let html = escape(text);

    // Images inside links: [![alt](src)](href)
    html = html.replace(
        /\[!\[([^\]]*)]\(([^)]+)\)]\(([^)]+)\)/g,
        '<a href="$3" target="_blank" rel="noopener noreferrer"><img src="$2" alt="$1"></a>'
    );

    // Images: ![alt](src)
    html = html.replace(
        /!\[([^\]]*)]\(([^)]+)\)/g,
        '<img src="$2" alt="$1">'
    );

    // Links: [text](href)
    html = html.replace(
        /\[([^\]]+)]\(([^)]+)\)/g,
        '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
    );

    // Bold / italic / inline code
    html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    html = html.replace(/\*([^*]+)\*/g, '<em>$1</em>');
    html = html.replace(/`([^`]+)`/g, '<code>$1</code>');

    return html;
}

export function renderMarkdown(src) {
    if (!src) {
        return '';
    }

    const blocks = String(src).replace(/\r\n?/g, '\n').split(/\n{2,}/);
    const out = [];

    for (const raw of blocks) {
        const block = raw.trim();
        if (!block) continue;

        const lines = block.split('\n');

        if (lines.every((l) => HR_RE.test(l))) {
            out.push('<hr>');
            continue;
        }

        if (lines.some((l) => HR_RE.test(l))) {
            let buffer = [];
            const flushParagraph = () => {
                if (buffer.length === 0) return;
                const html = buffer.map((l) => renderInline(l)).join('<br>');
                out.push('<p>' + html + '</p>');
                buffer = [];
            };
            for (const line of lines) {
                if (HR_RE.test(line)) {
                    flushParagraph();
                    out.push('<hr>');
                } else {
                    buffer.push(line);
                }
            }
            flushParagraph();
            continue;
        }

        if (lines.every((l) => /^\s*[-*]\s+/.test(l))) {
            const items = lines
                .map((l) => l.replace(/^\s*[-*]\s+/, ''))
                .map((l) => '<li>' + renderInline(l) + '</li>')
                .join('');
            out.push('<ul>' + items + '</ul>');
            continue;
        }

        if (lines.every((l) => /^\s*\d+\.\s+/.test(l))) {
            const items = lines
                .map((l) => l.replace(/^\s*\d+\.\s+/, ''))
                .map((l) => '<li>' + renderInline(l) + '</li>')
                .join('');
            out.push('<ol>' + items + '</ol>');
            continue;
        }

        // GFM-style table: a header row with pipes followed by a separator row
        // matching `:?-+:?` per column. Body rows are everything after.
        if (lines.length >= 2 && lines[0].includes('|') && TABLE_SEP_RE.test(lines[1])) {
            out.push(renderTable(lines));
            continue;
        }

        const h2 = block.match(/^##\s+(.*)$/);
        if (h2) {
            out.push('<h2>' + renderInline(h2[1]) + '</h2>');
            continue;
        }

        const h3 = block.match(/^###\s+(.*)$/);
        if (h3) {
            out.push('<h3>' + renderInline(h3[1]) + '</h3>');
            continue;
        }

        const withBreaks = lines.map((l) => renderInline(l)).join('<br>');
        out.push('<p>' + withBreaks + '</p>');
    }

    return out.join('');
}
